<template>
  <v-layout
    fill-height
    fluid
    column
  >
    <v-layout
      column
      shrink
      pa-1
    >
      <v-flex xs12>Settings</v-flex>
    </v-layout>
    <v-divider color="white"></v-divider>
    <v-flex xs12>
      <v-layout
        pl-1
        pr-1
        pt-0
        pb-0
        row
        align-center
        shrink
      >
        <v-flex shrink xs8 style="cursor:pointer;" @click="$player.toggleLoop()">Loop</v-flex>
        <v-flex xs4 shrink>
          <v-switch v-model="loop" dark ></v-switch>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12>
      <v-layout
        pl-1
        pr-1
        pt-0
        pb-0
        fill-height
        fluid
        row
        @click="showQualitySettings"
        align-center
        style="cursor:pointer;"
      >
        <v-flex xs5>Quality</v-flex>
        <v-flex xs5><span class="caption red--text">{{selectedQuality}}</span></v-flex>
        <v-flex xs2 shrink><v-icon dark>keyboard_arrow_right</v-icon></v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
/* eslint func-names: ["error", "never"] */
/* eslint object-shorthand: 0 */
export default {
  name: 'PlayerSettings',
  data() {
    return {
    };
  },
  computed: {
    selectedQuality() {
      return this.$store.state.selectedQuality;
    },
    loop: {
      get() {
        return this.$store.state.loopEnabled;
      },
      set() {
        this.$player.toggleLoop();
      },
    },
  },
  methods: {
    showQualitySettings() {
      this.$emit('update:quality', true);
    },
  },
};
</script>

<style scoped>
</style>
